import React, { useContext, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import {
  Button,
  Card,
  Chip,
  CircularProgress,
  Grid,
  IconButton,
  InputBase,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Dialog,
  useMediaQuery,
  useTheme,
  Typography,
} from '@mui/material';
import searchIcon from 'assets/svg/searchIcon.svg';
import { DEPOSIT_MANAGER } from 'constant/app.config';
import { getApiCall, postApiCall } from 'api/apiService';
import SelectBuyerTable from './StatusDetailsPopups/SelectBuyerTable';
import PaymentHistoryPopup from './PaymentHistoryPopup';
import DetailsPopup from './StatusDetailsPopups/DetailsPopup';
import RequestDepositPaymentPopup from './RequestDepositPaymentPopup';
import { Pendingwarning } from 'component/BuyersMarketplace/MakeOffers';
import { REFUND_STATUS_AGENT } from 'constant/app.config';
import Swal from 'sweetalert2';
import { poppins500, poppins400 } from 'theme/common.style';
import { datacontext } from 'modules/AppLayout/AppLayout';
import ConfirmRefundPopup from './ConfirmRefundPopup';
import moment from 'moment';
import { RequestIcon } from 'component/BuyerRegistration/Table';
import InitiateDepositRefund from './InitiateDepositRefund';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';

const FilterIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.8811 10.5609C12.8811 9.66929 12.1151 8.94345 11.172 8.94345C10.2299 8.94345 9.46293 9.66929 9.46293 10.5609C9.46293 11.4524 10.2299 12.1783 11.172 12.1783C12.1151 12.1783 12.8811 11.4524 12.8811 10.5609ZM14.3909 10.5609C14.3909 12.2402 12.9475 13.6071 11.172 13.6071C9.3975 13.6071 7.95312 12.2402 7.95312 10.5609C7.95312 8.88154 9.3975 7.51465 11.172 7.51465C12.9475 7.51465 14.3909 8.88154 14.3909 10.5609ZM25.0645 10.5611C25.0645 10.1667 24.7263 9.84665 24.3096 9.84665H18.1194C17.7027 9.84665 17.3645 10.1667 17.3645 10.5611C17.3645 10.9554 17.7027 11.2755 18.1194 11.2755H24.3096C24.7263 11.2755 25.0645 10.9554 25.0645 10.5611ZM20.1362 20.0532C20.1362 20.9447 20.9022 21.6706 21.8453 21.6706C22.7884 21.6706 23.5544 20.9447 23.5544 20.0532C23.5544 19.1606 22.7884 18.4358 21.8453 18.4358C20.9022 18.4358 20.1362 19.1606 20.1362 20.0532ZM18.6264 20.0532C18.6264 18.3729 20.0698 17.007 21.8453 17.007C23.6208 17.007 25.0642 18.3729 25.0642 20.0532C25.0642 21.7325 23.6208 23.0994 21.8453 23.0994C20.0698 23.0994 18.6264 21.7325 18.6264 20.0532ZM8.70873 19.3385H14.8979C15.3146 19.3385 15.6528 19.6585 15.6528 20.0529C15.6528 20.4472 15.3146 20.7673 14.8979 20.7673H8.70873C8.29203 20.7673 7.95383 20.4472 7.95383 20.0529C7.95383 19.6585 8.29203 19.3385 8.70873 19.3385Z"
        fill="#666666"
      />
      <rect
        opacity="0.1"
        x="0.5"
        y="0.5"
        width="31"
        height="31"
        rx="4.5"
        stroke="#112347"
      />
    </svg>
  );
};

const RefundIcon = () => (
  <div className="refund-icon-wrapper">
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.5 1.75C15.3326 1.75 19.25 5.66738 19.25 10.5C19.25 15.3326 15.3326 19.25 10.5 19.25C8.45993 19.253 6.48345 18.5402 4.91489 17.2358L4.70139 17.0529L5.49064 15.3886C6.61762 16.5437 8.10909 17.2739 9.71261 17.4557C11.3161 17.6374 12.9332 17.2595 14.2901 16.386C15.647 15.5124 16.6604 14.1969 17.1588 12.6619C17.6572 11.127 17.6099 9.46708 17.025 7.96303C16.44 6.45897 15.3534 5.20322 13.949 4.40831C12.5445 3.6134 10.9086 3.32817 9.31801 3.60088C7.72743 3.8736 6.27994 4.68752 5.22053 5.90488C4.16112 7.12224 3.55486 8.66825 3.50439 10.2812L3.50001 10.5H5.68751L3.31976 15.5015C2.29532 14.0351 1.74724 12.2888 1.75001 10.5C1.75001 5.66738 5.66739 1.75 10.5 1.75ZM11.375 5.25V7H13.5625V8.75H8.75001C8.64068 8.7498 8.53524 8.79054 8.45445 8.86419C8.37366 8.93785 8.32337 9.03909 8.31349 9.14797C8.30362 9.25685 8.33486 9.36548 8.40108 9.45248C8.46729 9.53947 8.56368 9.59852 8.67126 9.618L8.75001 9.625H12.25C12.8302 9.625 13.3866 9.85547 13.7968 10.2657C14.207 10.6759 14.4375 11.2323 14.4375 11.8125C14.4375 12.3927 14.207 12.9491 13.7968 13.3593C13.3866 13.7695 12.8302 14 12.25 14H11.375V15.75H9.62501V14H7.43751V12.25H12.25C12.3593 12.2502 12.4648 12.2095 12.5456 12.1358C12.6264 12.0621 12.6766 11.9609 12.6865 11.852C12.6964 11.7432 12.6652 11.6345 12.5989 11.5475C12.5327 11.4605 12.4363 11.4015 12.3288 11.382L12.25 11.375H8.75001C8.16985 11.375 7.61345 11.1445 7.20321 10.7343C6.79298 10.3241 6.56251 9.76766 6.56251 9.1875C6.56251 8.60734 6.79298 8.05094 7.20321 7.6407C7.61345 7.23047 8.16985 7 8.75001 7H9.62501V5.25H11.375Z" />
    </svg>
  </div>
);

const ConfirmIcon = () => (
  <div className="confirm-icon-wrapper">
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.5 2.5C7.64348 2.5 5.86301 3.2375 4.55025 4.55025C3.2375 5.86301 2.5 7.64348 2.5 9.5C2.5 11.3565 3.2375 13.137 4.55025 14.4497C5.86301 15.7625 7.64348 16.5 9.5 16.5C11.3565 16.5 13.137 15.7625 14.4497 14.4497C15.7625 13.137 16.5 11.3565 16.5 9.5C16.5 7.64348 15.7625 5.86301 14.4497 4.55025C13.137 3.2375 11.3565 2.5 9.5 2.5ZM0.75 9.5C0.75 4.66738 4.66738 0.75 9.5 0.75C14.3326 0.75 18.25 4.66738 18.25 9.5C18.25 14.3326 14.3326 18.25 9.5 18.25C4.66738 18.25 0.75 14.3326 0.75 9.5ZM13.581 6.65888C13.7542 6.81304 13.8592 7.02966 13.8728 7.26116C13.8864 7.49266 13.8076 7.72009 13.6536 7.8935L8.98725 13.1435C8.90516 13.2359 8.80443 13.3098 8.69169 13.3605C8.57896 13.4111 8.45677 13.4373 8.33319 13.4373C8.2096 13.4373 8.08742 13.4111 7.97468 13.3605C7.86195 13.3098 7.76122 13.2359 7.67912 13.1435L5.34637 10.5185C5.20123 10.3439 5.12963 10.1197 5.14672 9.89331C5.1638 9.6669 5.26822 9.456 5.43792 9.30516C5.60762 9.15431 5.82931 9.07534 6.05616 9.08492C6.28301 9.0945 6.49725 9.19188 6.65362 9.3565L8.33362 11.2456L12.3464 6.73063C12.5007 6.55751 12.7173 6.45272 12.9488 6.43926C13.1803 6.42581 13.4077 6.5048 13.581 6.65888Z" />
    </svg>
  </div>
);

const ArrowGrayIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.17934 8.19976L18.5856 1.9904C18.6448 1.96776 18.7092 1.96275 18.7712 1.97596C18.8332 1.98917 18.89 2.02005 18.9348 2.06486C18.9796 2.10966 19.0105 2.16649 19.0237 2.22846C19.0369 2.29043 19.0319 2.35491 19.0093 2.41409L12.7999 18.8203C12.7752 18.8826 12.732 18.9359 12.6762 18.9729C12.6203 19.01 12.5545 19.029 12.4875 19.0275C12.4205 19.026 12.3555 19.004 12.3014 18.9644C12.2473 18.9249 12.2065 18.8698 12.1847 18.8064L9.42024 11.9941C9.38801 11.8976 9.33377 11.8099 9.2618 11.7379C9.18983 11.6659 9.10211 11.6117 9.00557 11.5794L2.19328 8.81745C2.12911 8.7961 2.0731 8.75544 2.03292 8.70103C1.99274 8.64663 1.97036 8.58113 1.96883 8.51352C1.96731 8.4459 1.98671 8.37946 2.02439 8.3233C2.06208 8.26713 2.11619 8.22398 2.17934 8.19976Z"
        stroke="#666666"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.8691 2.13281L9.3125 11.6895"
        stroke="#666666"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const EyeIcon = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.875 9.5C11.875 10.1299 11.6248 10.734 11.1794 11.1794C10.734 11.6248 10.1299 11.875 9.5 11.875C8.87011 11.875 8.26602 11.6248 7.82062 11.1794C7.37522 10.734 7.125 10.1299 7.125 9.5C7.125 8.87011 7.37522 8.26602 7.82062 7.82062C8.26602 7.37522 8.87011 7.125 9.5 7.125C10.1299 7.125 10.734 7.37522 11.1794 7.82062C11.6248 8.26602 11.875 8.87011 11.875 9.5Z"
        fill="#666666"
      />
      <path
        d="M17.3349 9.14678C15.6265 5.72915 12.5928 3.95898 9.50218 3.95898C6.41231 3.95898 3.37785 5.72915 1.66943 9.14678C1.61452 9.25666 1.58594 9.37781 1.58594 9.50065C1.58594 9.62349 1.61452 9.74464 1.66943 9.85453C3.37785 13.2722 6.41151 15.0423 9.50218 15.0423C12.5921 15.0423 15.6265 13.2722 17.3349 9.85453C17.3898 9.74464 17.4184 9.62349 17.4184 9.50065C17.4184 9.37781 17.3898 9.25666 17.3349 9.14678ZM9.50218 13.459C7.15172 13.459 4.7506 12.1765 3.27176 9.50065C4.7506 6.82482 7.15093 5.54232 9.50218 5.54232C11.8526 5.54232 14.2538 6.82482 15.7326 9.50065C14.2538 12.1765 11.8526 13.459 9.50218 13.459Z"
        fill="#666666"
      />
    </svg>
  );
};

const DepositManagerTabs = (props) => {
  const { handleClosedeposit, profileDetails, getListInfo, fromVendorStatus } =
    props;
  const [value, setValue] = React.useState('1');

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabStyle = {
    textTransform: 'capitalize',
    fontFamily: 'poppins',
    fontWeight: 500,
    fontSize: matchessm ? '12px' : '14px',
    color: '#666666',
  };

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <TabContext value={value}>
          <Box>
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              TabIndicatorProps={{ style: { backgroundColor: '#6C2AD2' } }} // Indicator color
              sx={{
                '& .MuiTab-root': {
                  //   color: "#6C2AD2", // Unselected tab color
                  marginRight: matchessm ? '-10px' : '72px', // Spacing between tabss
                },
                '& .Mui-selected': {
                  color: '#6C2AD2 !important', // Selected tab text color
                },
                '& .MuiTab-root.Mui-selected::after': {
                  backgroundColor: '#6C2AD2 !important', // Selected tab text color
                },
              }}
            >
              <Tab sx={tabStyle} label="All Deposits" value="1" />
              <Tab sx={tabStyle} label="Requested" value="2" />
              <Tab sx={tabStyle} label="Paid" value="3" />
              <Tab sx={tabStyle} label="Refund" value="4" />
            </TabList>
          </Box>
          <TabPanel
            classes={{
              '& .MuiBox-root': {
                padding: 'auto 0px ',
              },
            }}
            value="1"
          >
            <AllDepositTab
              handleClosedeposit={handleClosedeposit}
              profileDetails={profileDetails}
              getListInfo={getListInfo}
              tabValue={'All'}
              fromVendorStatus={fromVendorStatus}
            />
          </TabPanel>
          <TabPanel value="2">
            <AllDepositTab
              handleClosedeposit={handleClosedeposit}
              profileDetails={profileDetails}
              tabValue={'Requested'}
              getListInfo={getListInfo}
              fromVendorStatus={fromVendorStatus}
            />
          </TabPanel>
          <TabPanel value="3">
            <AllDepositTab
              handleClosedeposit={handleClosedeposit}
              profileDetails={profileDetails}
              getListInfo={getListInfo}
              tabValue={'Paid'}
              fromVendorStatus={fromVendorStatus}
            />
          </TabPanel>
          <TabPanel value="4">
            <AllDepositTab
              handleClosedeposit={handleClosedeposit}
              profileDetails={profileDetails}
              getListInfo={getListInfo}
              tabValue={'Refunded'}
              fromVendorStatus={fromVendorStatus}
            />
          </TabPanel>
        </TabContext>
      </Box>
    </>
  );
};

const AllDepositTab = (props) => {
  const {
    handleClosedeposit,
    profileDetails,
    tabValue,
    getListInfo,
    fromVendorStatus,
  } = props;

  const location = useLocation();
  const { dashboardConfiremDepositBanner } = location?.state || {};

  const clearDashboardState = () => {
    if (dashboardConfiremDepositBanner) {
      history.push({
        pathname: history.location.pathname,
        state: { dashboardConfiremDepositBanner: false },
      });
    }
  };

  const { realTimeLog, setShowMessage, setMessagedata } =
    useContext(datacontext);

  const propertyId = profileDetails?.PropertyDetails?.property?.propertyId;

  const tableHeadingStyle = {
    textTransform: 'capitalize',
    fontFamily: 'poppins',
    fontWeight: 600,
    fontSize: '13px',
    color: '#666666',
    py: 0,
    height: 30,
    lineHeight: '30px',
  };
  const tableDataStyle = {
    textTransform: 'capitalize',
    fontFamily: 'poppins',
    fontWeight: 400,
    fontSize: '12px',
    color: '#666666',
  };

  const [openDetailsPopup, setOpenDetailsPopup] = useState(false);
  const [buyerId, setBuyerId] = useState();
  const [initiatedepositrefund, setInitiateDepositRefund] = useState(false);
  const handleCloses = () => {
    setInitiateDepositRefund(false);
  };

  const handleOpenDetails = () => {
    setOpenDetailsPopup(true);
  };
  const handleCloseDetails = () => {
    setOpenDetailsPopup(false);
  };

  const getChipStylesByStatus = (status) => {
    switch (status) {
      case 'Paid':
        return { backgroundColor: '#CEFECE', color: '#3FBA20' };
      case 'Requested':
        return { backgroundColor: '#F3E8FE', color: '#8424D5' };
      case 'Refunded':
        return { backgroundColor: '#FEEDD6', color: '#B46E46' };
      case 'Partially Paid':
        return { backgroundColor: '#DCEAFE', color: '#3854B7' };
      case 'Viewed':
        return { backgroundColor: '#E0E7FE', color: '#3E50BB' };
      case 'Overdue':
        return { backgroundColor: '#FDE2E2', color: '#B44E4F' };
      case 'Transferred':
        return { backgroundColor: '#E2FDFC', color: '#03C6DB' };
      default:
        return { backgroundColor: '#E0E0E0', color: '#000000' };
    }
  };

  const [actionBuyer, setActionBuyer] = useState();
  const [actionBuyerId, setActionBuyerId] = useState();

  const [actionRefundBuyerId, setActionRefundBuyerId] = useState();
  const [actionBuyerRefund, setActionBuyerRefund] = useState();

  const history = useHistory();
  const OpenBinderChat = (currentBinder) => {
    if (currentBinder) {
      setShowMessage(true);
      setMessagedata({ binderId: currentBinder });
    }
  };

  const ActionIcons = (status, row) => {
    const iconProps = {
      ConfirmIcon: {
        color: '#40AB5F',
        tooltip: 'Mark as received',
      },
      RefundIcon: {
        color: '#EA4342',
        tooltip: 'Process Refund',
      },
      ArrowGrayIcon: {
        color: '#666666',
        // tooltip: "Transfer to next",
      },
    };

    const renderIconButton = (IconComponent, key, color, tooltip) => (
      <Tooltip
        title={tooltip}
        placement="top"
        key={key}
        sx={{ fontFamily: 'poppins', fontWeight: 500 }}
        componentsProps={{
          popper: {
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 4], // ↓ Reduce this to bring tooltip closer (default is [0, 8])
                },
              },
            ],
          },
        }}
      >
        <IconButton
          onClick={() => {
            clearDashboardState();
            if (key === 'confirm') {
              setPaymentHistoryPopup(true);
              setActionBuyerId(row?.buyerId);
              setActionBuyer(row);
            } else if (key === 'refund') {
              // setConfirmDepositRequest(true);
              setInitiateDepositRefund(true);
              setActionRefundBuyerId(row?.buyerId);
              setActionBuyerRefund(row);
            } else if (key === 'OverdueIcon') {
              OpenBinderChat(row?.binderId);
            }
          }}
          disabled={key === 'refund'}
          sx={{
            color: '#666666',
            fontFamily: 'poppins',
            fontWeight: 500,
            '&:hover': {
              color,
              backgroundColor: 'transparent',
            },
          }}
        >
          <IconComponent />
        </IconButton>
      </Tooltip>
    );

    switch (status?.trim()) {
      case 'Paid':
        return [
          renderIconButton(
            RefundIcon,
            'refund',
            iconProps.RefundIcon.color,
            iconProps.RefundIcon.tooltip
          ),
        ];
      case 'Requested':
        return [];
      case 'Refunded':
        return [];
      case 'Partially Paid':
        return [
          renderIconButton(
            ConfirmIcon,
            'confirm',
            iconProps.ConfirmIcon.color,
            iconProps.ConfirmIcon.tooltip
          ),
          renderIconButton(
            RefundIcon,
            'refund',
            iconProps.RefundIcon.color,
            iconProps.RefundIcon.tooltip
          ),
        ];
      case 'Viewed':
        return [];
      case 'Overdue':
        return [
          renderIconButton(
            ArrowGrayIcon,
            'OverdueIcon',
            iconProps.ArrowGrayIcon.color,
            iconProps.ArrowGrayIcon.tooltip
          ),
        ];
      case 'Transferred':
        return [
          renderIconButton(
            ConfirmIcon,
            'confirm',
            iconProps.ConfirmIcon.color,
            iconProps.ConfirmIcon.tooltip
          ),
          renderIconButton(
            RefundIcon,
            'refund',
            iconProps.RefundIcon.color,
            iconProps.RefundIcon.tooltip
          ),
        ];
      default:
        return [];
    }
  };

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matchesxs = useMediaQuery(theme.breakpoints.down(500));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const isXsScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const matches400 = useMediaQuery(theme.breakpoints.down(600));
  const matches750 = useMediaQuery(theme.breakpoints.down(750));
  const matches800 = useMediaQuery(theme.breakpoints.down(850));
  const matches900 = useMediaQuery(theme.breakpoints.down(900));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matches380 = useMediaQuery(theme.breakpoints.down(380));

  const [Confirmdepositrequestopen, setConfirmDepositRequest] = useState(false);

  const [openBuyerListPopup, setOpenBuyerListPopup] = useState(false);

  const handleOpen = () => {
    setOpenBuyerListPopup(true);
  };
  const handleClose = () => {
    setOpenBuyerListPopup(false);
  };

  const [PaymentHistoryPopupopen, setPaymentHistoryPopup] = useState(false);
  const handleClosePopup = () => {
    setActionBuyerId(null);
    setPaymentHistoryPopup(false);
  };

  const [depositTableData, setDepositTableData] = useState({});
  const [depositTableLoader, setDepositTableLoader] = useState(false);

  const formattedDate = (val) => {
    return;
    moment(val).format('DD-MM-YYYY HH:MM');
  };

  let accesstoken = 'Bearer ' + localStorage.getItem('accesstoken');

  const getTableData = async () => {
    setDepositTableLoader(true);
    try {
      const res = await getApiCall(
        `${DEPOSIT_MANAGER}/${tabValue}/${propertyId}`,
        {
          method: 'GET',
          headers: {
            Authorization: accesstoken,
            'Content-Type': 'application/json',
          },
        }
      );

      if (res?.data?.status == 1) {
        setDepositTableData(res?.data);
      }
    } catch (error) {
      console.error('Error fetching deposit table data:', error);
    } finally {
      setDepositTableLoader(false);
    }
  };

  useEffect(() => {
    getTableData();
  }, [realTimeLog]);

  let tableData = depositTableData?.depositManagerDetails;

  const [openRequestDeposit, setOpenRequestDeposit] = useState(false);

  const data = [
    {
      title: 'Total Requested',
      value: tableData?.formattedTotalRequestedAmount ?? '$0.00',
    },
    {
      title: 'Total Received',
      value: tableData?.formattedTotalReceivedAmount ?? '$0.00',
    },
    {
      title: 'Outstanding',
      value: tableData?.formattedOutStandingAmount ?? '$0.00',
    },
  ];

  const CommaSeprateValue = (val) => {
    return val?.toLocaleString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  return (
    <>
      <Grid container spacing={2} mt={matchessm ? 0 : 1}>
        {data.map((item, index) => (
          <Grid item xs={12} sm={4} key={index}>
            <Card
              sx={{
                borderRadius: '20px',
                padding: 2,
                boxShadow: 'rgba(0, 0, 0, 0.20) 0px 1px 4px',
              }}
            >
              <Box
                sx={{
                  fontFamily: 'Poppins',
                  fontWeight: 600,
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  marginBottom: '8px',
                }}
              >
                {item.title}
              </Box>
              <Box
                sx={{
                  fontFamily: 'Poppins',
                  fontWeight: 500,
                  fontSize: matchessm ? '18px' : '24px',
                  color: '#000000',
                }}
              >
                {item.value}
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Stack flexDirection={'row'} textAlign={'center'} gap={1} sx={{ mt: 5 }}>
        <Box
          component="form"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#F2F2F2',
            borderRadius: '30px',
            width: '236px',
            height: '32px',
          }}
        >
          <IconButton
            disabled
            sx={{ p: '7px', paddingLeft: '20px' }}
            aria-label="search"
          >
            <img alt="searchIcon" src={searchIcon} />
          </IconButton>
          <InputBase
            sx={{
              ml: 1,
              flex: 1,
              '& input::placeholder': {
                color: '#666666 !important',
                fontSize: '12px',
                fontWeight: 400,
                fontFamily: 'poppins',
                opacity: 1,
              },

              fontSize: '12px',
              fontWeight: 400,
              fontFamily: 'poppins',
            }}
            placeholder="Search here"
            inputProps={{
              'aria-label': 'Search here',
            }}
          />
        </Box>
        <FilterIcon />
      </Stack>
      {/* Table */}
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: '5px',
          overflow: 'hidden',
          border: '1px solid #E9E9E9',
          mt: 3,
          overflowX: 'auto',
          maxHeight: 423,
          minHeight: '457px',
          overflowY: 'auto',
        }}
      >
        <Table stickyHeader sx={{ minWidth: '1100px' }}>
          <TableHead>
            <TableRow sx={{ height: 30, minHeight: 30 }}>
              <TableCell sx={tableHeadingStyle}>Buyer Name</TableCell>
              <TableCell sx={tableHeadingStyle}>Deposit Requested</TableCell>
              <TableCell sx={tableHeadingStyle}>Paid Amount</TableCell>
              <TableCell sx={tableHeadingStyle}>%</TableCell>
              <TableCell sx={tableHeadingStyle}>Status</TableCell>
              <TableCell sx={tableHeadingStyle}>Requested Date</TableCell>
              <TableCell sx={tableHeadingStyle}>Last Updated</TableCell>
              <TableCell sx={tableHeadingStyle} align="center">
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          {depositTableLoader ? (
            <TableBody>
              <TableRow>
                <TableCell colSpan={8}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '390px',
                    }}
                  >
                    <CircularProgress sx={{ color: '#666666' }} />
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          ) : tableData?.depositDetails?.length === 0 || !tableData ? (
            <TableBody>
              <TableRow>
                <TableCell colSpan={8}>
                  <Box
                    sx={{
                      height: '390px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontFamily: 'poppins',
                      fontSize: '14px',
                      fontWeight: 500,
                      color: '#666666',
                    }}
                  >
                    No data found
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          ) : (
            <TableBody>
              {tableData?.depositDetails?.map((row, index) => (
                <TableRow key={index}>
                  <TableCell sx={tableDataStyle}>{row.buyerName}</TableCell>
                  <TableCell sx={tableDataStyle}>
                    {row.formattedRequestAmount ?? '$0.00'}
                  </TableCell>
                  <TableCell sx={tableDataStyle}>
                    {row.formattedPaidAmount ?? '$0.00'}
                  </TableCell>
                  <TableCell sx={tableDataStyle}>
                    {row.percentage ?? '-'}
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={row.status}
                      variant="container"
                      sx={{
                        ...getChipStylesByStatus(row.status),
                        fontWeight: 600,
                        fontSize: '13px',
                        borderRadius: '25px',
                        fontFamily: 'poppins',
                      }}
                    />
                  </TableCell>
                  <TableCell sx={tableDataStyle}>
                    {moment(row.requestDate).format('DD-MM-YYYY HH:mm') ?? '-'}
                  </TableCell>
                  <TableCell sx={tableDataStyle}>
                    {moment(row.lastUdpated).format('DD-MM-YYYY HH:mm') ?? '-'}
                  </TableCell>
                  <TableCell sx={tableDataStyle} align="right">
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      justifyContent={'end'}
                    >
                      {ActionIcons(row?.status, row)}
                      <Button
                        variant="outlined"
                        startIcon={<EyeIcon />}
                        size="small"
                        onClick={() => {
                          clearDashboardState();
                          handleOpenDetails();
                          setBuyerId(row?.buyerId);
                        }}
                        sx={{
                          borderRadius: '5px',
                          border: '1px solid #C4C4C4',
                          color: '#666666',
                          height: '23px',
                          width: '100px',
                          textTransform: 'capitalize',
                          textAlign: 'center',
                          '&:hover': {
                            border: '1px solid #C4C4C4',
                            color: '#666666',
                          },
                        }}
                      >
                        Details
                      </Button>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
      </TableContainer>
      <Grid
        container
        justifyContent={matchessm ? 'space-between' : 'flex-end'}
        gap={matchessm ? 0 : 2}
        sx={{
          position: 'sticky',
          bottom: 0,
          backgroundColor: '#fff',
          borderTop: '1px solid #E0E0E0',
          paddingTop: 2,
          paddingBottom: 2,
          zIndex: 5,
        }}
      >
        <Grid item>
          <Button
            onClick={() => {
              clearDashboardState();
              handleClosedeposit();
            }}
            variant="outlined"
            sx={{
              px: matchessm ? '15px' : '39px',
              height: '41px',
              fontSize: matchessm ? '12px' : '14px',
              color: '#666666',
              fontWeight: 400,
              fontFamily: 'Poppins',
              border: '1px solid rgba(17, 35, 71, 0.1)',
              borderRadius: '5px',
              textTransform: 'none',
            }}
          >
            Cancel
          </Button>
        </Grid>

        <Grid item>
          <Button
            startIcon={<RequestIcon color={'#ffff'} />}
            variant="outlined"
            onClick={() => {
              clearDashboardState();
              setOpenRequestDeposit(true);
            }}
            sx={{
              px: matchessm ? '15px' : '39px',
              width: '100%',
              height: '41px',
              fontSize: matchessm ? '12px' : '14px',
              color: '#FFFFFF',
              fontWeight: 400,
              fontFamily: 'poppins',
              backgroundColor: '#4CA4D6',
              borderRadius: '5px',
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#4CA4D6',
                color: '#FFF',
              },
            }}
          >
            Request Deposit
          </Button>
        </Grid>
      </Grid>
      {openDetailsPopup && (
        <DetailsPopup
          openDetailsPopup={openDetailsPopup}
          handleCloseDetails={handleCloseDetails}
          profileDetails={profileDetails}
          buyerId={buyerId}
          getTableData={getTableData}
          setInitiateDepositRefund={setInitiateDepositRefund}
          tableData={tableData}
          setActionBuyerRefund={setActionBuyerRefund}
          setActionBuyerId={setActionBuyerId}
          setActionBuyer={setActionBuyer}
          actionBuyerRefund={actionBuyerRefund}
          actionRefundBuyerId={actionRefundBuyerId}
          getListInfo={getListInfo}
          fromVendorStatus={fromVendorStatus}
        />
      )}

      <RequestDepositPaymentPopup
        openRequestDeposit={openRequestDeposit}
        setOpenRequestDeposit={setOpenRequestDeposit}
        // depositDetailsData={depositDetailsData}
        tableData={tableData}
        buyerId={buyerId}
        profileDetails={profileDetails}
        isAllBuyer={true}
        getTableData={getTableData}
        getListInfo={getListInfo}
      />

      <ConfirmRefundPopup
        open={Confirmdepositrequestopen}
        setConfirmDepositRequest={setConfirmDepositRequest}
        profileDetails={profileDetails}
        actionBuyerRefund={actionBuyerRefund}
        actionRefundBuyerId={actionRefundBuyerId}
        getTableData={getTableData}
        setActionBuyerId={setActionBuyerId}
        setActionBuyer={setActionBuyer}
        setActionBuyerRefund={setActionBuyerRefund}
        isTable={true}
      />

      {PaymentHistoryPopupopen && (
        <PaymentHistoryPopup
          open={PaymentHistoryPopupopen}
          setPaymentHistoryPopup={setPaymentHistoryPopup}
          onClose={handleClosePopup}
          actionBuyerId={actionBuyerId}
          setActionBuyerId={setActionBuyerId}
          actionBuyer={actionBuyer}
          setActionBuyer={setActionBuyer}
          getTableData={getTableData}
          getListInfo={getListInfo}
        />
      )}

      <InitiateDepositRefund
        open={initiatedepositrefund}
        onClose={handleCloses}
        profileDetails={profileDetails}
        actionBuyerRefund={actionBuyerRefund}
        actionRefundBuyerId={actionRefundBuyerId}
        getTableData={getTableData}
        setActionBuyerId={setActionBuyerId}
        setActionBuyer={setActionBuyer}
        setActionBuyerRefund={setActionBuyerRefund}
        isTable={true}
        tableData={tableData}
        setInitiateDepositRefund={setInitiateDepositRefund}
      />
    </>
  );
};

export default DepositManagerTabs;
